import { Component, OnInit, ChangeDetectorRef, inject } from '@angular/core';
import { CadastroService } from '../../../../services/cadastro.service';
import { Servico } from '../../../../models/cadastro.model';
import { Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ErrorModel } from '../../../../models/error.model';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-servicos',
  standalone: true,
  imports: [CommonModule, FormsModule],
  templateUrl: './servicos.component.html',
  styleUrls: ['./servicos.component.css']
})
export class ServicosComponent implements OnInit {
  servicos: Servico[] = [];
  filteredServicos: Servico[] = [];
  paginatedServicos: Servico[] = [];
  
  currentPage = 1;
  itemsPerPage = 10;
  totalPages = 1;
  maxPagesToShow = 5;
  startPage!: number;
  endPage!: number;
  pages: number[] = [];

  searchTerm = '';

  constructor(
    private cadastroService: CadastroService, 
    private router: Router,
    private toastr: ToastrService
  ) { }
  
  private cdr = inject(ChangeDetectorRef);

  ngOnInit(): void {
    this.loadServicos();
  } 

  loadServicos(): void {
    this.cadastroService.getServicos().subscribe(data => {
      this.servicos = data;
      this.filteredServicos = data;
      this.totalPages = Math.max(1, Math.ceil(this.filteredServicos.length / this.itemsPerPage));
      this.setPage(1);
      this.cdr.detectChanges();
    });
  }

  search(): void {
    this.filteredServicos = this.servicos.filter(servico =>
      servico.nome.toLowerCase().includes(this.searchTerm.toLowerCase()) ||
      servico.descricao.toLowerCase().includes(this.searchTerm.toLowerCase())
    );
    this.totalPages = Math.max(1, Math.ceil(this.filteredServicos.length / this.itemsPerPage));
    this.setPage(1);
  }

  setPage(page: number): void {
    if (page < 1 || page > this.totalPages) {
      return;
    }
    this.currentPage = page;
    const startIndex = (this.currentPage - 1) * this.itemsPerPage;
    const endIndex = Math.min(startIndex + this.itemsPerPage, this.filteredServicos.length);
    this.paginatedServicos = this.filteredServicos.slice(startIndex, endIndex);
    this.updatePageNumbers();
  }

  updatePageNumbers(): void {
    const halfPages = Math.floor(this.maxPagesToShow / 2);
    this.startPage = Math.max(1, this.currentPage - halfPages);
    this.endPage = Math.min(this.totalPages, this.startPage + this.maxPagesToShow - 1);

    if (this.endPage - this.startPage + 1 < this.maxPagesToShow) {
      this.startPage = Math.max(1, this.endPage - this.maxPagesToShow + 1);
    }

    this.pages = Array.from(
      { length: (this.endPage - this.startPage) + 1 },
      (_, i) => this.startPage + i
    );
  }

  novoServico(): void {
    this.router.navigate(['/home', 'cadastro-servico-manutencao']);
  }

  editarServico(id: number): void {
    this.router.navigate(['/home', 'cadastro-servico-manutencao', id]);
  }

  deleteServico(id: number): void {
     this.cadastroService.deleteServico(id).subscribe({
       next: () => {
         this.loadServicos();
         this.toastr.success('Serviço excluído com sucesso!');
       },
       error: (error) => {
         var erro: ErrorModel = error.error;
         this.toastr.error(erro.message);
       }});
  }
}
